import DashboardNotFunded from './DashboardNotFunded';

export default DashboardNotFunded;
